/* FreezPaw cats page (assets/fzk-cats.js): Quick Shop modal + FAQ accordion.
   Modal follows Osmo "Basic Modal Setup" (group status attribute, dark overlay closes, Escape closes). */
(function () {
  'use strict';
  if (window.__fzkInit) return; window.__fzkInit = true;

  var DATA = {};
  try { DATA = JSON.parse((document.getElementById('fzk-qs-data') || {}).textContent || '{}'); } catch (e) {}
  var modal = document.querySelector('[data-fzk-modal]');
  if (!modal) return;
  var $ = function (sel) { return modal.querySelector(sel); };
  var COLORS = { purple: '#8e3fb0', white: '#f4f4f4', aqua: '#7fd1b9', pink: '#f4a6c0', cream: '#efe6d5', coral: '#e8705f', blue: '#1f3a8a', green: '#2f5d3a', yellow: '#f2c230', orange: '#f74e00', red: '#c62828', black: '#111111', silver: '#c9ccd1', grey: '#9e9e9e', gray: '#9e9e9e', navy: '#1f3a8a', teal: '#2a9d8f', mint: '#7fd1b9', lavender: '#b39ddb', 'light blue': '#7dbde8' };
  var money = function (c) { return '$' + (c / 100).toFixed(2); };
  var cur = null, vsel = null, lastFocus = null;

  function setImage(src) { var im = $('[data-fzk-qs-img]'); if (src && im.getAttribute('src') !== src) im.src = src; }
  function setVariant(v) {
    vsel = v;
    $('[data-fzk-qs-price]').textContent = money(v.price);
    var was = $('[data-fzk-qs-was]'); was.textContent = v.was > v.price ? money(v.was) : '';
    var add = $('[data-fzk-qs-add]');
    add.disabled = !v.ok;
    add.textContent = v.ok ? 'Add to cart · ' + money(v.price) : 'Sold out';
    if (v.img) setImage(v.img);
    Array.prototype.forEach.call(modal.querySelectorAll('[data-fzk-qs-opts] button'), function (b) { b.setAttribute('aria-pressed', String(+b.dataset.id === v.id)); });
  }

  function open(handle, opener) {
    var p = DATA[handle]; if (!p) return;
    cur = p; lastFocus = opener || document.activeElement;
    $('[data-fzk-qs-title]').textContent = p.title;
    $('[data-fzk-qs-desc]').textContent = p.desc || '';
    $('[data-fzk-qs-qty]').value = 1;
    var im = $('[data-fzk-qs-img]'); im.alt = p.title; im.removeAttribute('src'); setImage(p.images[0]);
    var th = $('[data-fzk-qs-thumbs]'); th.innerHTML = '';
    p.thumbs.forEach(function (t, i) {
      var b = document.createElement('button'); b.type = 'button'; b.setAttribute('aria-label', 'Photo ' + (i + 1));
      b.innerHTML = '<img src="' + t + '" alt="" loading="lazy" width="80" height="80">';
      b.addEventListener('click', function () { setImage(p.images[i]); });
      th.appendChild(b);
    });
    var wrap = $('[data-fzk-qs-optwrap]'), opts = $('[data-fzk-qs-opts]'); opts.innerHTML = '';
    wrap.hidden = !!p.single;
    $('[data-fzk-qs-optname]').textContent = (p.option || 'Option') + ':';
    if (!p.single) p.variants.forEach(function (v) {
      var b = document.createElement('button'); b.type = 'button'; b.dataset.id = v.id;
      var c = COLORS[String(v.title).toLowerCase()];
      b.className = 'fzk-sw__b' + (c ? ' fzk-sw__b--c' : '');
      if (c) b.style.setProperty('--sw', c); else b.textContent = v.title.replace(' Paste Sticks', ' sticks');
      b.title = v.title + (v.ok ? '' : ' · sold out'); b.setAttribute('aria-label', v.title + (v.ok ? '' : ' (sold out)'));
      if (!v.ok) b.disabled = true;
      b.addEventListener('click', function () { setVariant(v); });
      opts.appendChild(b);
    });
    var first = p.variants.filter(function (v) { return v.ok; })[0] || p.variants[0];
    setVariant(first);
    modal.setAttribute('data-modal-group-status', 'active'); modal.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('fzk-lock');
    setTimeout(function () { var c = $('.fzk-modal__close'); if (c) c.focus({ preventScroll: true }); }, 30);
  }
  function close() {
    if (modal.getAttribute('data-modal-group-status') !== 'active') return;
    modal.setAttribute('data-modal-group-status', 'not-active'); modal.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('fzk-lock');
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-fzk-qs]');
    if (t) { e.preventDefault(); open(t.getAttribute('data-fzk-qs'), t); return; }
    if (e.target.closest && e.target.closest('[data-fzk-close]')) { close(); return; }
    var q = e.target.closest && e.target.closest('[data-fzk-qty]');
    if (q) { var inp = $('[data-fzk-qs-qty]'); inp.value = Math.max(1, Math.min(20, (+inp.value || 1) + (+q.getAttribute('data-fzk-qty')))); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  /* keep keyboard focus inside the open card */
  modal.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab') return;
    var f = Array.prototype.filter.call(modal.querySelectorAll('button:not([disabled]), input'), function (el) { return el.offsetParent !== null; });
    if (!f.length) return;
    if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
    else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
  });

  $('[data-fzk-qs-add]').addEventListener('click', function () {
    var b = this; if (!vsel || b.disabled) return;
    var qty = Math.max(1, +$('[data-fzk-qs-qty]').value || 1), label = b.textContent;
    b.disabled = true; b.textContent = 'Adding…';
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: vsel.id, quantity: qty }] }) })
      .then(function (r) { if (!r.ok) throw r; return r.json(); })
      .then(function () {
        close();
        if (window.FzCart && window.FzCart.open) window.FzCart.open(); else window.location.href = '/cart';
      })
      .catch(function () { b.textContent = 'Try again'; setTimeout(function () { b.textContent = label; }, 1800); })
      .then(function () { b.disabled = !vsel.ok; if (b.textContent === 'Adding…') b.textContent = label; });
  });


  /* smooth scroll for in-page links (hero button, Build your set) */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href^="#fzk"]');
    if (!a) return;
    var t = document.querySelector(a.getAttribute('href')); if (!t) return;
    e.preventDefault();
    var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: t.getBoundingClientRect().top + window.scrollY - 90, behavior: reduce ? 'auto' : 'smooth' });
  });

  /* ---------- Osmo animations (GSAP 3.13 + ScrollTrigger + SplitText). Without GSAP, everything simply shows. ---------- */
  var root = document.querySelector('.fzk');
  var reduceMotion = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hasGsap = typeof window.gsap !== 'undefined' && typeof window.ScrollTrigger !== 'undefined';
  if (root && hasGsap && !reduceMotion) {
    gsap.registerPlugin(ScrollTrigger);
    if (window.SplitText) gsap.registerPlugin(SplitText);
    root.classList.add('fzk-anim');

    /* Osmo "Highlight Marker Text Reveal": a bar covers each line, then scales away on scroll */
    var initMarkers = function () {
      if (!window.SplitText) { gsap.set('[data-highlight-marker-reveal]', { autoAlpha: 1 }); return; }
      var dirMap = { right: { prop: 'scaleX', origin: 'right center' }, left: { prop: 'scaleX', origin: 'left center' }, up: { prop: 'scaleY', origin: 'center top' }, down: { prop: 'scaleY', origin: 'center bottom' } };
      root.querySelectorAll('[data-highlight-marker-reveal]').forEach(function (el) {
        var dir = dirMap[el.getAttribute('data-marker-direction')] || dirMap.right;
        var color = el.getAttribute('data-marker-theme') || '#f74e00';
        var inst = {};
        el._fzkMarker = inst;
        SplitText.create(el, {
          type: 'lines', linesClass: 'highlight-marker-line', autoSplit: true,
          onSplit: function (self) {
            if (inst.tl) inst.tl.kill(); if (inst.st) inst.st.kill();
            el.querySelectorAll('.highlight-marker-bar').forEach(function (b) { b.remove(); });
            if (inst.done) { gsap.set(el, { autoAlpha: 1 }); return; }  /* already revealed: a resize must not cover it again */
            var tl = gsap.timeline({ paused: true });
            self.lines.forEach(function (line, i) {
              gsap.set(line, { position: 'relative', overflow: 'hidden' });
              var bar = document.createElement('div'); bar.className = 'highlight-marker-bar';
              bar.style.backgroundColor = color; bar.style.transformOrigin = dir.origin;
              line.appendChild(bar);
              var o = {}; o[dir.prop] = 0; o.duration = 0.6; o.ease = 'power3.inOut';
              tl.to(bar, o, i * 0.1);
            });
            gsap.set(el, { autoAlpha: 1 });
            inst.tl = tl;
            tl.eventCallback('onComplete', function () { inst.done = true; el.querySelectorAll('.highlight-marker-bar').forEach(function (b) { b.remove(); }); });
            inst.st = ScrollTrigger.create({ trigger: el, start: 'top 90%', once: true, onEnter: function () { inst.done = true; tl.play(); } });
          }
        });
      });
    };

    /* Osmo "Elements Reveal on Scroll": groups of cards rise in with a stagger */
    var initReveal = function () {
      root.querySelectorAll('[data-reveal-group]').forEach(function (group) {
        var stagger = (parseFloat(group.getAttribute('data-stagger')) || 100) / 1000;
        var dist = group.getAttribute('data-distance') || '2em';
        var slots = [];
        Array.prototype.forEach.call(group.children, function (child) {
          var nested = child.querySelector('[data-reveal-group-nested]');
          if (nested) Array.prototype.forEach.call(nested.children, function (n) { slots.push(n); });
          else slots.push(child);
        });
        if (!slots.length) return;
        gsap.set(slots, { y: dist, autoAlpha: 0 });
        ScrollTrigger.create({
          trigger: group, start: group.getAttribute('data-start') || 'top 82%', once: true,
          onEnter: function () {
            gsap.to(slots, { y: 0, autoAlpha: 1, duration: 0.8, ease: 'power4.inOut', stagger: stagger, onComplete: function () { gsap.set(slots, { clearProps: 'all' }); } });
          }
        });
      });
    };

    initReveal();
    (document.fonts && document.fonts.ready ? document.fonts.ready : Promise.resolve()).then(initMarkers);
    /* safety: never leave a heading hidden */
    setTimeout(function () { root.querySelectorAll('[data-highlight-marker-reveal]').forEach(function (el) { if (getComputedStyle(el).visibility === 'hidden') gsap.set(el, { autoAlpha: 1 }); }); }, 3000);
  }

  /* FAQ: Osmo "Accordion CSS Animation" behaviour, one open at a time */
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('.fzk-faq__top');
    if (!t) return;
    var item = t.parentNode, wrap = item.parentNode, isOpen = !item.classList.contains('is-open');
    Array.prototype.forEach.call(wrap.querySelectorAll('.fzk-faq__item.is-open'), function (o) {
      if (o !== item) { o.classList.remove('is-open'); o.querySelector('.fzk-faq__top').setAttribute('aria-expanded', 'false'); }
    });
    item.classList.toggle('is-open', isOpen); t.setAttribute('aria-expanded', String(isOpen));
  });
})();
